//////////////////////////////////////////////////////////////////////////////
// Stockists List Functionality
//////////////////////////////////////////////////////////////////////////////

// Check if stockistsData is available
if (typeof stockistsData !== 'undefined') {
  // Log stockists data for debugging
  // console.log(stockistsData.stockists);

  //////////////////////////////////////////////////////////////////////////////
  // Map configuration including search radius
  //////////////////////////////////////////////////////////////////////////////
  const mapConfig = {
    radius: 15000 // 15 kilometers radius
  };

  //////////////////////////////////////////////////////////////////////////////
  // Function to check if Google Maps API is loaded
  //////////////////////////////////////////////////////////////////////////////
  function checkGoogleMapsAPI() {
    if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
      initAutocomplete(); // Initialise autocomplete functionality
    } else {
      setTimeout(checkGoogleMapsAPI, 1000);
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to initialise Google Places Autocomplete
  //////////////////////////////////////////////////////////////////////////////
  function initAutocomplete() {
    const input = document.querySelector('.js-place-search');
    const autocomplete = new google.maps.places.Autocomplete(input);

    autocomplete.addListener('place_changed', function () {
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        return;
      }
      const userLocation = place.geometry.location;
      updateStockistsList(userLocation);
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to update the stockists list based on user location
  //////////////////////////////////////////////////////////////////////////////
  function updateStockistsList(userLocation) {
    const userBounds = new google.maps.Circle({
      center: userLocation,
      radius: mapConfig.radius
    }).getBounds();

    const stockists = stockistsData.stockists
      .map(stockist => {
        const stockistLocation = new google.maps.LatLng(stockist.lat, stockist.lng);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, stockistLocation);
        return { ...stockist, distance };
      })
      .filter(stockist => userBounds.contains(new google.maps.LatLng(stockist.lat, stockist.lng)));

    stockists.sort((a, b) => a.distance - b.distance);
    displayStockists(stockists);
    resetLocationButton();
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to display the stockists in the list
  //////////////////////////////////////////////////////////////////////////////
  function displayStockists(stockists) {
    const stockistsList = document.querySelector('.js-stockists-list');
    stockistsList.innerHTML = '';
    stockists.forEach(stockist => {
      const listItem = document.createElement('div');
      listItem.className = 'col-12 mb-4';
      listItem.innerHTML = `
      <div class="card card-call-stockist-list bg-white">
        <div class="card-body px-0">
          <div class="container-fluid px-0">
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-1">
                <span class="card-title d-block h4 text-body">${stockist.title}</span>
                <p class="card-text harmony-charcoal mb-0">${stockist.address}</p>
                <p class="card-text harmony-charcoal mb-0">
                  <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(stockist.address)}" target="_blank" class="text-body js-directions-link">Directions</a>
                </p>
                <p class="card-text harmony-charcoal mb-0">Phone: <a href="tel:${stockist.phone}" class="text-body text-decoration-none">${stockist.phone}</a></p>
              </div>
              <div class="col-12 col-lg-3">
                <a href="tel:${stockist.phone}" class="btn btn-primary">Call Now</a>
                <a href="${stockist.link}" class="btn btn-primary-outline ms-2 ms-lg-0">View Stockist</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

      stockistsList.appendChild(listItem);
    });
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to initialise the stockists list on page load
  //////////////////////////////////////////////////////////////////////////////
  function initStockistsList() {
    const sortedStockists = [...stockistsData.stockists].sort((a, b) => a.title.localeCompare(b.title));
    displayStockists(sortedStockists);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to handle "Use My Location" button click
  //////////////////////////////////////////////////////////////////////////////
  function handleUseMyLocation() {
    const locationLoading = document.querySelector('.js-location-loading');
    const useMyLocation = document.querySelector('.js-use-my-location');
    const locationStatus = document.querySelector('.js-location-status');
    const searchInput = document.querySelector('.js-place-search');

    // Clear the search input
    searchInput.value = '';

    // Show the loading indicator and hide the use my location button and status
    locationLoading.style.display = 'block';
    useMyLocation.style.display = 'none';
    locationStatus.style.display = 'none';

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        updateStockistsList(userLocation);

        // Show the location status and hide the loading indicator
        locationLoading.style.display = 'none';
        useMyLocation.style.display = 'none';
        locationStatus.style.display = 'block';
      }, () => {
        // Handle geolocation error
        locationLoading.style.display = 'none';
        useMyLocation.style.display = 'block';
        alert("Unable to retrieve your location.");
      });
    } else {
      // Handle case where geolocation is not supported
      locationLoading.style.display = 'none';
      useMyLocation.style.display = 'block';
      alert("Geolocation is not supported by this browser.");
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to handle "View All Locations" button click
  //////////////////////////////////////////////////////////////////////////////
  function handleViewAllLocations() {
    const searchInput = document.querySelector('.js-place-search');
    const sortedStockists = [...stockistsData.stockists].sort((a, b) => a.title.localeCompare(b.title));

    searchInput.value = '';
    displayStockists(sortedStockists);
    resetLocationButton();
  }

  //////////////////////////////////////////////////////////////////////////////
  // Function to reset location button to "Use My Location"
  //////////////////////////////////////////////////////////////////////////////
  function resetLocationButton() {
    const locationStatus = document.querySelector('.js-location-status');
    const useMyLocation = document.querySelector('.js-use-my-location');
    const locationLoading = document.querySelector('.js-location-loading');

    locationStatus.style.display = 'none';
    locationLoading.style.display = 'none';
    useMyLocation.style.display = 'block';
  }

  //////////////////////////////////////////////////////////////////////////////
  // Initialise the script on DOM content loaded
  //////////////////////////////////////////////////////////////////////////////
  document.addEventListener('DOMContentLoaded', function () {
    checkGoogleMapsAPI();
    initStockistsList();

    document.querySelector('.js-use-my-location').addEventListener('click', handleUseMyLocation);
    document.querySelector('.js-view-all-locations').addEventListener('click', handleViewAllLocations);
  });
}